import {get, post} from "@/utils/request";

export const saveCookies = (params) => {
    return post("v3_1/cookie/save", params);
}

export const handleCmdData = (data) => {
    return post("tikhoknew/manage/cmd", data);
}
